var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5C11.5523 5 12 4.55228 12 4C12 3.44772 11.5523 3 11 3ZM8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4C14 5.65685 12.6569 7 11 7C9.34315 7 8 5.65685 8 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9C3 8.44772 3.44772 8 4 8H9C9.55228 8 10 8.44772 10 9V14.5C10 15.0523 9.55228 15.5 9 15.5H6.5V21.5C6.5 22.0523 6.05228 22.5 5.5 22.5C4.94772 22.5 4.5 22.0523 4.5 21.5V14.5C4.5 13.9477 4.94772 13.5 5.5 13.5H8V10H4C3.44772 10 3 9.55229 3 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C12 8.44772 12.4477 8 13 8H18.0909C18.6432 8 19.0909 8.44772 19.0909 9C19.0909 9.55229 18.6432 10 18.0909 10H14V14.0185L20.7106 20.7964C21.0992 21.1889 21.096 21.8221 20.7036 22.2106C20.3111 22.5992 19.6779 22.596 19.2894 22.2036L12.2894 15.1334C12.104 14.9461 12 14.6933 12 14.4298V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.0747d039bae00c0a6a6db79c3e9e741d.svg";
export { ForwardRef as ReactComponent };